import { environment } from '../../environments/environment';

export const WPS_ENDPOINT = environment.wpsEndpoint;
